module.exports = __webpack_public_path__ + "static/media/lucky-wheel-img-4.8f4747c9.png";